<template>
  <div class="page" v-loading="loading">
    <div class="filter-wrapper">
      <el-form
        ref="form"
        inline
        :model="form"
        @submit.native.prevent="handleSubmit('form')"
      >
        <el-form-item prop="begin_date_and_end_date" :rules="{ required: true, message: '请选择时间区间' }">
          <el-date-picker
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            v-model="form.begin_date_and_end_date"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" native-type="submit">查询</el-button>
          <el-button type="primary" @click="exportData" :loading="exporting" :disabled="exporting" >导出数据</el-button>
        </el-form-item>
        <div class="switch-area">
          <el-form-item v-for="item in switchOptions" :key="item.prop" :label="item.label">
            <v-node :render-node="item.metaRender"></v-node>
            <el-switch v-model="form[item.prop]"></el-switch>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="chart-area">
      <div class="chart-wrapper" v-for="(options, index) in optionsList" :key="index">
        <c-echarts v-if="options" :options="options" />
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import _ from 'lodash'
import switchOptions from './switch-options.js'
import moment from 'moment';

@Component
export default class BaseData extends Vue {

  optionsList = []
  loading = false;
  exporting = false;

  form = {
    // 默认选中一周
    begin_date_and_end_date: [moment().add('days', -6), moment()].map((ele) => ele.format('YYYY-MM-DD')),
    amount_with_refund: true
  }
  switchOptions = switchOptions;

  pickerOptions = {
    disabledDate(current) {
      return moment(new Date()).diff(moment(current)) < 0 || moment().add(-1, 'y').diff(moment(current)) > 0;
    }
  }

  async handleSubmit(formName) {
    await this.$refs[formName].validate();
    this.loading = true;
    this.fetchData().finally(() => this.loading = false);
  }

  async exportData() {
    await this.$refs['form'].validate();
    if (_.filter(this.form, (value) => value === true).length === 0) {
      this.$alert('请选择要导出的项');
    } else {
      this.exporting = true;
      try {
        await this.$download({
          url: '/statistics/export_analyses',
          params: this.form,
          name: _.get(this.$route, 'meta.title', 'resource') + '.xlsx'
        });
      } finally {
        this.exporting = false;
      }
    }
  }

  async fetchData() {
    const data = await this.$request.get('/statistics/analyses', { params: this.form })
    this.optionsList = _.map(data, (value, key) => {
      const datas = value.data_source

      const item = _.find(switchOptions, (o) => o.prop === key)
      const title = item && `${item.label}: ${value.period_data}`

      return {
        title: {
          text: title,
          textStyle: {
            fontStyle: 14
          }
        },
        xAxis: {
          type: 'category',
          data: _.keys(datas),
          axisLabel: {
            fontWeight: 800
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            fontWeight: 800
          }
        },
        series: [{
          data: _.values(datas),
          type: 'line',
          smooth: true,
          areaStyle: { opacity: 0.5 }
      }]
      }
    })
  }
}
</script>


<style lang="scss" scoped>

.filter-wrapper {
  margin-top: 1em;

  /deep/ .item-16 {
    display: block !important;
  }

  &:after {
    content: '';
    clear: both;
    display: table;
  }
}

.switch-area {
  .el-form-item {
    margin-right: 40px;
  }
}

.chart-area {
  margin-top: 3em;

  .chart-wrapper {
    float: left;

    .echarts {
      width: 500px;
      height: 350px;
    }
  }
}

</style>

<style lang="scss">
  .base-data-meta-info {
    span {
      font-weight: 800;
    }

    p {
      margin: 0.2em 0;
    }
  }

  .base-data-meta-info-icon {
    margin-left: -10px;
    margin-right: 10px;
    cursor: pointer;
  }
</style>
